// extracted by mini-css-extract-plugin
module.exports = {"buttonsList":"SignatureBillet_buttonsList__JzfyM","buttonItem":"SignatureBillet_buttonItem__2JnMv"};